import { useEffect, useRef } from "react";

import { CALL_STATUS } from "@/constants/call";
import { useCall } from "@/providers/hooks/use-call";
import type { CallStatus } from "@/types/call.types";

const ACTIVE_CALL_STATUSES: CallStatus[] = [CALL_STATUS.CONNECTING, CALL_STATUS.RINGING, CALL_STATUS.CONNECTED];
const IN_CALL_FAVICON_PATH = "/elitphone-incall-icon.svg";

const getFaviconLink = (): HTMLLinkElement | null => {
    const existingFavicon = document.querySelector('link[rel="icon"]');
    if (existingFavicon instanceof HTMLLinkElement) {
        return existingFavicon;
    }

    const newFavicon = document.createElement("link");
    newFavicon.rel = "icon";
    document.head.appendChild(newFavicon);

    return newFavicon;
};

export function CallFaviconIndicator() {
    const { callStatus } = useCall();
    const originalHrefRef = useRef<string | null>(null);
    const originalTypeRef = useRef<string | null>(null);

    useEffect(() => {
        const faviconLink = getFaviconLink();
        if (!faviconLink) {
            return;
        }

        if (!originalHrefRef.current) {
            originalHrefRef.current = faviconLink.href;
            originalTypeRef.current = faviconLink.type || null;
        }

        const isCallActive = ACTIVE_CALL_STATUSES.includes(callStatus);
        if (isCallActive) {
            faviconLink.href = IN_CALL_FAVICON_PATH;
            faviconLink.type = "image/png";
            return;
        }

        if (originalHrefRef.current) {
            faviconLink.href = originalHrefRef.current;
            faviconLink.type = originalTypeRef.current || "image/png";
        }
    }, [callStatus]);

    useEffect(() => {
        return () => {
            const faviconLink = getFaviconLink();
            if (!faviconLink || !originalHrefRef.current) {
                return;
            }

            faviconLink.href = originalHrefRef.current;
            faviconLink.type = originalTypeRef.current || "image/png";
        };
    }, []);

    return null;
}
